import { Suspense, lazy, useState } from 'react';
import { FileInput } from 'lucide-react';
import { Button } from '@/components/ui';

// The dialog and the edit-file parsers load on first use.
const PremiereImportDialog = lazy(() => import('./PremiereImportDialog'));

/** "Import from Premiere…": imports a Premiere/Final Cut XML/FCPXML/EDL edit as new projects. */
export function PremiereImportButton({ orgId, spaceId, folderId, onCreated }: { orgId: string; spaceId: string; folderId: string; onCreated: (projectId: string) => void }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)} data-import-premiere title="Premiere Pro project or XML, FCPXML or EDL">
        <FileInput size={16} /> Import from Premiere…
      </Button>
      {open ? (
        <Suspense fallback={null}>
          <PremiereImportDialog orgId={orgId} spaceId={spaceId} folderId={folderId} onClose={() => setOpen(false)} onCreated={onCreated} />
        </Suspense>
      ) : null}
    </>
  );
}
